import { Button } from '@optools/components/ui/button';
import { Calendar } from '@optools/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@optools/components/ui/popover';
import { formatYearMonthDayHourMinuteSecond } from '@optools/utils/datetime';
import { CalendarIcon } from 'lucide-react';
import { useState } from 'react';

import { TimePicker } from './time-picker';

export interface DateTimePickerProps {
  date: Date;
  setDate: (date: Date) => void;
}

export function DateTimePicker({ date, setDate }: DateTimePickerProps) {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  return (
    <Popover open={isCalendarOpen} onOpenChange={setIsCalendarOpen}>
      <PopoverTrigger asChild>
        <Button
          aria-label="date calendar"
          className="w-max items-center justify-center text-left font-normal"
          variant="outline">
          <CalendarIcon className="size-4" />
          <span>{formatYearMonthDayHourMinuteSecond(date)}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" side="right">
        <Calendar
          defaultMonth={date}
          mode="single"
          selected={date}
          onSelect={(selectedDate) => {
            if (!selectedDate) return;
            setDate(selectedDate);
          }}
        />
        <div className="border-t border-border p-3">
          <TimePicker date={date} setDate={setDate} />
        </div>
      </PopoverContent>
    </Popover>
  );
}
